import ClipCard from '@/components/video/ClipCard';
import type { Clip, ReviewStatus } from '@/types/job';

interface ClipsListProps {
  clips: Clip[];
  onReview?: (clipIndex: number, status: ReviewStatus) => void;
}

export default function ClipsList({ clips, onReview }: ClipsListProps) {
  if (clips.length === 0) {
    return <p className="text-sm text-muted-foreground text-center py-8">No clips extracted yet.</p>;
  }

  const approved = clips.filter((c) => c.reviewStatus === 'approved').length;
  const rejected = clips.filter((c) => c.reviewStatus === 'rejected').length;
  const pending = clips.length - approved - rejected;

  return (
    <div className="space-y-4">
      {onReview && (
        <div className="flex items-center gap-4 text-xs text-muted-foreground">
          <span>
            {clips.length} clip(s): <span className="text-green-600 font-medium">{approved} approved</span>,{' '}
            <span className="text-destructive font-medium">{rejected} rejected</span>,{' '}
            <span className="font-medium">{pending} pending</span>
          </span>
          {pending === 0 && <span className="text-green-600 font-medium">All reviewed</span>}
        </div>
      )}
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {clips.map((clip) => (
          <ClipCard key={clip.index} clip={clip} onReview={onReview} />
        ))}
      </div>
    </div>
  );
}
